<div class="content">
    
    <mat-dialog-content>
       <p>Exiting out of this loan application will submit what has been completed so far.</p>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button mat-button class="btn btn-secondary" (click)="closeAndSubmit()">Close & Submit</button>
        <button mat-button class="btn btn-primary" (click)="keepEditing()">Keep Editing</button>
    </div>
</div>
